export interface CountDownInterface {
  hours: number;
  minutes: number;
  seconds: number;
  isAhead?: boolean;
}
/**
 * Calculates the difference between the given countdown end time and the current local time.
 * @param countdownEndTime The end time of the countdown in string format.
 * @returns An object representing the difference between the countdown end time and the current local time.
 */
export const getTimeDifference = (countdownEndTime: string): CountDownInterface => {
  // Convert countdown end time to a Date object
  const countdownEndDate = new Date(countdownEndTime);
  const localDate = new Date();

  // Calculate the time difference between countdown end time and current local time
  const timeDifference = countdownEndDate.getTime() - localDate.getTime();

  // Determine if the countdownEndTime is ahead or behind the current local time
  const isAhead = timeDifference > 0;

  if (isAhead) {
    // Calculate hours, minutes, and seconds remaining until the countdown end time
    const totalHours = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    return {
      hours: totalHours,
      minutes,
      seconds,
      isAhead,
    };
  }
  return {
    hours: 0,
    minutes: 0,
    seconds: 0,
    isAhead,
  };
};
